import React from 'react';
import { Users } from 'lucide-react';

const BusinessDevAdmin = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
          <Users className="w-7 h-7 text-purple-600 dark:text-purple-400" />
          Business Development Admin
        </h1>
        <p className="text-gray-600 dark:text-gray-400">Business development insights and analytics</p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <p className="text-gray-600 dark:text-gray-400">
          Business Development dashboard coming soon...
        </p>
      </div>
    </div>
  );
};

export default BusinessDevAdmin;
